export const ERROR_MESSAGE_ADD_CARD = "Credit Card can't be added at the moment.";
export const ERROR_MESSAGE_DELETE_CARD = "Credit Card can't be deleted at the moment.";
export const ERROR_MESSAGE_SET_DEFAULT_CARD = "Credit Card can't be set as Primary at the moment.";
export const CARD_DECLINED = 'Your card was declined.';
